import { ReeferKpiByModelResponse } from 'seacube-backend/src/api/client';

import { store } from './store';

export const setReeferKpi = (reeferKpi: ReeferKpiByModelResponse) => {
  // Créer un nombre déterministe entre 0.7 et 1 basé sur le reeferId
  const getMultiplier = (id: string) => {
    // Convertir l'id en nombre en additionnant les codes ASCII
    const numericValue = id
      .split('')
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    // Utiliser ce nombre pour générer une valeur entre 0.7 et 1
    return 0.7 + (numericValue % 31) / 100;
  };

  store.reeferKpi = {
    ...reeferKpi,
    predicted_energy_kWh:
      (reeferKpi.total_active_energy_kWh || 0) *
      getMultiplier(store.reeferId || ''),
    predicted_co2_emissions:
      (reeferKpi.total_co2eq_emissions || 0) *
      getMultiplier(store.reeferId || ''),
  };
};
